export var RATING_TEXT_MAP = {
  0: 'Нет рейтинга',
  1: 'Очень плохо',
  2: 'Плохо',
  3: 'Неплохо',
  4: 'Очень хорошо',
  5: 'Отлично'
};